// Granular cookie consent manager — v2
// Stores preferences in localStorage; also maintains legacy cookie for cached bundle compat.

const KEY = "aof-consent-v2";

export function getConsent() {
  try {
    const s = localStorage.getItem(KEY);
    return s ? JSON.parse(s) : null;
  } catch { return null; }
}

export function setConsent({ analytics, marketing }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ analytics: !!analytics, marketing: !!marketing }));
    // Keep legacy aofConsent cookie so any cached bundles still using getCookieConsentValue() work
    const age = 150 * 24 * 60 * 60;
    document.cookie = `aofConsent=${analytics ? "true" : "false"}; max-age=${age}; path=/; SameSite=Lax`;
  } catch {}
}

export function hasAnalyticsConsent() {
  const c = getConsent();
  return c !== null && c.analytics === true;
}

export function hasMarketingConsent() {
  const c = getConsent();
  return c !== null && c.marketing === true;
}

export function hasGivenConsent() {
  return getConsent() !== null;
}

export function resetConsent() {
  try {
    localStorage.removeItem(KEY);
    document.cookie = "aofConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  } catch {}
}

// One-time migration from the old react-cookie-consent simple cookie
export function migrateOldConsent() {
  if (getConsent() !== null) return;
  try {
    const old = document.cookie.split("; ").find(r => r.startsWith("aofConsent="));
    if (old) {
      const val = old.split("=")[1];
      setConsent({ analytics: val === "true", marketing: false });
    }
  } catch {}
}
